import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/common';
import {
  Hero,
  ImageSlider,
  HowItWorks,
  MenuPricing,
  MenuSelection,
  Gallery,
  Booking,
  CustomerReviews,
  FAQ,
  Contact,
  SpecialOffer,
  Newsletter,
  PriceCalculator,
  InstagramFeed,
  ReferralProgram,
  PhotoShare,
} from '../components';
import type { FeatureToggles } from '../types';

const DEFAULT_TOGGLES: FeatureToggles = {
  photoShare: true,
  referralProgram: true,
  newsletter: true,
  specialOffer: true,
  instagramFeed: true,
  coupons: true,
};

/**
 * Home page component
 * Combines all main sections of the landing page
 */
const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const [features, setFeatures] = useState<FeatureToggles>(DEFAULT_TOGGLES);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const res = await fetch('/api/settings');
        const data = await res.json();
        if (data.success && data.settings?.featureToggles) {
          setFeatures({ ...DEFAULT_TOGGLES, ...data.settings.featureToggles });
        }
      } catch {
        // 使用默认值
      }
    };
    fetchFeatures();
  }, []);
  
  return (
    <>
      <SEO
        title={t('nav.home', 'Home')}
        description={t('seo.homeDescription', 'Top Rated Hibachi At Home Experience. We bring our Hibachi Grill + Chef to your backyard in California, Texas, and Florida.')}
      />
      <Hero />
      <ImageSlider />
      <HowItWorks />
      <MenuPricing />
      <PriceCalculator />
      <MenuSelection />
      <Gallery />
      <CustomerReviews />
      <Booking />
      {features.referralProgram && <ReferralProgram />}
      {features.instagramFeed && <InstagramFeed />}
      {features.photoShare && <PhotoShare />}
      <FAQ />
      {features.newsletter && <Newsletter />}
      <Contact />
      {features.specialOffer && <SpecialOffer />}
    </>
  );
};

export default HomePage;
